import useExclusion from '@/composables/exclusion';
import useRepo from '@/nebula/repo';
import { goal as goalConfig } from 'shared/api/query/configs.json';
import { useGoalExclusionCheck } from '@/composables/goal/goal-exclusion-check';

export default function useGoalsRepo(shouldExclude) {
  const repo = useRepo(goalConfig.model);
  const defaultShouldExclude = useGoalExclusionCheck();
  const exclusion = useExclusion(repo, goalConfig.model, shouldExclude ?? defaultShouldExclude.shouldExclude);

  const query = (queries, options = { excludeLoaded: false }) => {
    let modifiedQueries = queries;
    if (options.excludeLoaded === true) {
      modifiedQueries = exclusion.applyExclusion(queries);
    }

    return repo.query(modifiedQueries, options);
  };

  return {
    ...repo,

    query,
  };
}
